<div fxLayout="row" style="height: 100%">
	<div class="main-sidebar background-primary py1" fxLayout="column" fxLayoutAlign="space-between center" fxLayoutGap="8px">
		<div class="icon-text">
			<button mat-icon-button (click)="drawer.toggle()">
				@if (!drawer.opened) {
					<mat-icon>menu</mat-icon>
				}
				@if (drawer.opened) {
					<mat-icon>close</mat-icon>
				}
			</button>
			<span>{{ 'app.sidebar.services' | translate }}</span>
		</div>
		<div fxLayout="column" fxLayoutAlign="space-between center" fxLayoutGap="8px">
			@if (canEditEndpoint) {
				<div class="icon-text">
					<button mat-icon-button (click)="backendEndpointEditor()">
						<mat-icon>admin_panel_settings</mat-icon>
					</button>
					<span>{{ 'app.sidebar.localEndpointEditor' | translate }}</span>
				</div>
			}
			<div class="icon-text">
				<a mat-icon-button [href]="appService.docsUrl" target="_blank" rel="noopener">
					<mat-icon>description</mat-icon>
				</a>
				<span>{{ 'app.sidebar.docs' | translate }}</span>
			</div>
			<div class="icon-text">
				<a mat-icon-button href="mailto:{{ supportEMail }}" target="_blank" rel="noopener">
					<mat-icon>mail</mat-icon>
				</a>
				<span>{{ 'app.sidebar.contact' | translate }}</span>
			</div>
		</div>
	</div>
	<mat-drawer-container class="main-drawer">
		<mat-drawer #drawer mode="over">
			<div class="m2" fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="8px">
				<img class="toolbar-logo" alt="CANCOM Logo" src="../assets/cancom-red.svg" />

				<mat-form-field subscriptSizing="dynamic">
					<mat-label>{{ 'app.drawer.search' | translate }}</mat-label>
					<input matInput [formControl]="serviceSearch" tabindex="-1" />
					@if (serviceSearch.value) {
						<button matIconSuffix mat-icon-button aria-label="Clear" (click)="serviceSearch.setValue('')">
							<mat-icon>close</mat-icon>
						</button>
					}
				</mat-form-field>
			</div>
			<mat-divider class="mx2"></mat-divider>
			<ng-container *skeleton="!(services.length > 1); repeat: 20; height: '20px'; className: 'm2'">
				<div class="service-list m2">
					@for (service of filteredServices; track service) {
						<div (click)="openService(service); drawer.close()" fxLayoutAlign="start center">
							@if (selectedService === service.displayName) {
								<mat-icon class="color-primary px1">arrow_forward</mat-icon>
							}
							<strong
								[ngClass]="{
									'color-primary': selectedService === service.displayName,
									'service-unavailable': !allowedServices.includes(service.name),
								}"
							>
								{{ service.displayName }}
							</strong>
						</div>
					}
				</div>
			</ng-container>
		</mat-drawer>
		<mat-drawer-content fxLayout="column" width="100%">
			<mat-toolbar class="main-toolbar" fxLayout="row" fxLayoutAlign="space-between center">
				<div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="16px">
					<img class="toolbar-logo" alt="CANCOM Logo" src="../assets/cancom-red.svg" routerLink="/dashboard" />
					@if (stage === 'dev' || stage === 'staging') {
						<mat-chip disableRipple>
							{{ stage.toUpperCase() }}
						</mat-chip>
					}
				</div>
				<div fxLayout="row" fxLayoutGap="16px">
					<!-- NOTIFICATION BELL -->
					<ng-container>
						<button mat-icon-button [matMenuTriggerFor]="notificationsMenu" class="notification-button">
							<mat-icon [matBadge]="notifications.length || undefined" matBadgeColor="warn">notifications</mat-icon>
						</button>
						<mat-menu #notificationsMenu="matMenu" xPosition="before" class="notification-menu">
							<div fxLayout="column" class="m2" style="width: 100%">
								<div fxLayout="row" fxLayoutAlign="space-between center">
									<span>Notifications</span>
									<a routerLink="/notifications"><span>Show all</span></a>
								</div>
								<mat-divider class="my1"></mat-divider>
								<ng-container *ngIf="notifications.length === 0">
									<div
										fxLayout="column"
										fxLayoutAlign="center center"
										fxLayoutGap="16px"
										style="width: 100%; height: 100%"
									>
										<mat-icon style="transform: scale(2)">done_all</mat-icon>
										<span>No Notifications. You're all caught up!</span>
									</div>
								</ng-container>
								<ng-container *ngIf="notifications.length > 0">
									<div style="overflow-y: auto">
										<div
											mat-menu-item
											*ngFor="let notification of notifications"
											fxLayout="row"
											fxLayoutAlign="start center"
											style="min-height: 36px"
											[routerLink]="['notifications', notification.noteId]"
										>
											<span class="mr2 dot" [ngClass]="['dot-' + notification.noteType.toLowerCase()]"></span>
											<span>{{ notification.title }}</span>
											<!-- <span>
												<mat-icon *ngIf="!notification.requiresAction">warning</mat-icon>
											</span> -->
										</div>
									</div>
								</ng-container>
							</div>
						</mat-menu>
					</ng-container>
					<!-- Tenant Assumed Timeout -->
					@if (dateDiffRole === 0) {
						<div mat-button class="timeout-alert px2">{{ 'app.toolbar.expired' | translate }}</div>
					}
					<!-- Tenant -->
					@if (isLoggedIn) {
						@if ((userService.principalName | async) === (userService.userName | async)) {
							<button
								mat-button
								class="dark-button px2"
								[matMenuTriggerFor]="assumableRoles.length === 0 && wildcardRoles.length === 0 ? null : tenants"
							>
								<span fxLayout="row" fxLayoutAlign="start center">
									<span [ngClass]="{ loader: (userService.tenantName | async) === undefined }">
										@if (userService.impersonatedCRN) {
											{{ userService.impersonatedCRN.split(':')[1] }}
										} @else {
											{{ userService.tenantName | async }}
										}
									</span>
									@if (!(assumableRoles.length === 0 && wildcardRoles.length === 0)) {
										<mat-icon>keyboard_arrow_down</mat-icon>
									}
								</span>
							</button>
						}
						<!-- Tenant Assumed -->
						@else {
							<button mat-button class="dark-button pr2 pl0" [matMenuTriggerFor]="tenants">
								<span fxLayout="row" fxLayoutGap="8px" fxLayoutAlign="start center">
									@if (dateDiffRole) {
										<button mat-button class="countdown-button px2">
											<countdown
												[config]="{ leftTime: dateDiffRole, format: 'mm:ss', notify: [300, 60] }"
												(event)="handleEventRole($event)"
											></countdown>
										</button>
									}
									{{ userService.tenantName | async }}
									@if (userService.subaccount | async; as subaccount) {
										({{ subaccount }})
									}
									- {{ userService.principalName | async }}
									<mat-icon>keyboard_arrow_down</mat-icon>
								</span>
							</button>
						}
						<!-- Tenant Menu -->
						<mat-menu class="tenant-menu" #tenants="matMenu" xPosition="before">
							<!-- Role assumed - menu for leave -->
							@if ((userService.sessionToken | async) && (userService.sessionToken | async) !== impersonatedToken) {
								<button mat-menu-item (click)="userService.leaveRole()">
									<span fxLayout="row" fxLayoutGap="8px" fxLayoutAlign="start center">
										<mat-icon>exit_to_app</mat-icon>
										<span>{{ 'app.toolbar.tenant.leaveRole' | translate }}</span>
									</span>
								</button>
								<mat-divider class="my1"></mat-divider>
							}
							<ng-container class="p2" (click)="$event.stopPropagation()">
								<!-- WILDCARD -->
								@if (wildcardRoles.length > 0) {
									<button mat-menu-item (click)="changeContext()">
										<span fxLayout="row" fxLayoutGap="8px" fxLayoutAlign="start center">
											<mat-icon>manage_accounts</mat-icon>
											<span>{{ 'app.toolbar.tenant.changeContext' | translate }}</span>
										</span>
									</button>
									<mat-divider class="mb1"></mat-divider>
								}
								<!-- LAST USED ROLES -->
								@if (lastUsedRoles.length > 0 && !userService.impersonatedCRN) {
									<button mat-menu-item disabled style="min-height: 16px">
										{{ 'app.toolbar.tenant.lastUsedRoles' | translate }}
									</button>
									@for (obj of lastUsedRoles; track $index) {
										<button mat-menu-item [matMenuTriggerFor]="change">
											{{ obj.displayName || obj.tenant }}
										</button>
										<mat-menu #change="matMenu" class="fullwidth-menu" xPosition="before">
											@for (role of obj.roles; track $index) {
												<div fxLayout="row" fxLayoutAlign="start center">
													<button mat-menu-item (click)="assumeRoleSplit(obj.tenant, role.subaccount, role.role)">
														{{ role.role }}
														@if (role.subaccount) {
															<span>({{ role.subaccount }})</span>
														}
													</button>
													<button
														mat-icon-button
														class="mr1"
														(click)="removeLastUsedRole(obj.tenant, role.subaccount, role.role)"
													>
														<mat-icon>clear</mat-icon>
													</button>
												</div>
											}
										</mat-menu>
									}
									<mat-divider class="mb1"></mat-divider>
								}
								<!-- ASSUMABLE ROLES -->
								@if (assumableRoles.length > 0) {
									<button mat-menu-item disabled style="min-height: 16px">
										{{ 'app.toolbar.tenant.assumableTenants' | translate }}
									</button>
									@for (assumableRole of assumableRoles; track $index) {
										<button mat-menu-item (click)="changeContext(assumableRole)">
											{{ assumableRole.displayName }}
										</button>
									}
								}
							</ng-container>
						</mat-menu>
						<!-- Account -->
						<button
							mat-button
							[matMenuTriggerFor]="menu"
							class="round-button account-button"
							[ngClass]="isImpersonating ? 'pl0 pr2' : 'px2'"
						>
							<span fxLayout="row" fxLayoutGap="8px" fxLayoutAlign="start center">
								@if (isImpersonating) {
									<button mat-button class="countdown-button px2">
										<countdown
											[config]="{ leftTime: dateDiffImpersonation, format: 'mm:ss', notify: [300, 60] }"
											(event)="handleEventImpersonation($event)"
										></countdown>
									</button>
									{{ userService.impersonatedName }}
								} @else {
									{{ userService.userName | async }}
								}
								<mat-icon>keyboard_arrow_down</mat-icon>
							</span>
						</button>
						<!-- Account Menu -->
						<mat-menu #menu="matMenu" xPosition="before" class="fullwidth-menu">
							<div class="m2" fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="8px">
								<div fxLayout="column">
									<span>{{ 'app.toolbar.account.currentTenant' | translate }}</span>
									<span style="font-weight: lighter">{{ userService.currentTenant }}</span>
								</div>
								<button
									mat-icon-button
									(click)="copyIdToClipboard()"
									matTooltip="Copy Tenant ID to Clipboard"
									disableRipple
								>
									<mat-icon style="font-size: 20px">content_copy</mat-icon>
								</button>
							</div>
							<mat-divider></mat-divider>
							@if (!dateDiffImpersonation) {
								<button mat-menu-item routerLink="my-profile">
									<span fxLayout="row" fxLayoutGap="8px" fxLayoutAlign="start center">
										<mat-icon>account_circle</mat-icon>
										<span>{{ 'app.toolbar.account.myProfile' | translate }}</span>
									</span>
								</button>
								<button mat-menu-item (click)="createSessionToken()">
									<span fxLayout="row" fxLayoutGap="8px" fxLayoutAlign="start center">
										<mat-icon>key</mat-icon>
										<span>{{ 'app.toolbar.account.createSession' | translate }}</span>
									</span>
								</button>
								<button mat-menu-item (click)="logout()">
									<span fxLayout="row" fxLayoutGap="8px" fxLayoutAlign="start center">
										<mat-icon>logout</mat-icon>
										<span>{{ 'app.toolbar.account.logout' | translate }}</span>
									</span>
								</button>
							} @else {
								<button mat-menu-item (click)="userService.stopImpersonating()">
									<span fxLayout="row" fxLayoutGap="8px" fxLayoutAlign="start center">
										<mat-icon>logout</mat-icon>
										<span>{{ 'app.toolbar.account.stopImpersonating' | translate }}</span>
									</span>
								</button>
							}
							<button mat-menu-item (click)="themeService.toggleDarkTheme()">
								<span fxLayout="row" fxLayoutGap="8px" fxLayoutAlign="start center">
									@if (!themeService.darkMode) {
										<mat-icon>dark_mode</mat-icon>
										<span>{{ 'app.toolbar.account.toggleDarkMode' | translate }}</span>
									} @else {
										<mat-icon>light_mode</mat-icon>
										<span>{{ 'app.toolbar.account.toggleLightMode' | translate }}</span>
									}
								</span>
							</button>
						</mat-menu>
					}
				</div>
			</mat-toolbar>

			<div class="sidenav-container">
				<router-outlet></router-outlet>
			</div>

			<footer fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="24px">
				<span class="copyright">© CANCOM {{ currentYear }}</span>
				<div class="links" fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="16px" fxLayoutGap.lt-md="2px">
					<div fxLayoutGap="16px">
						<a href="https://www.cancom.com" target="_blank" rel="noopener">
							<span>CANCOM Group</span>
						</a>
						<a href="mailto:{{ supportEMail }}" target="_blank" rel="noopener">
							<span>{{ 'app.footer.contact' | translate }}</span>
						</a>
						<a href="https://www.cancom.de/en/imprint/" target="_blank" rel="noopener">
							<span>{{ 'app.footer.imprint' | translate }}</span>
						</a>
					</div>
					<div fxLayoutGap="16px">
						<a href="https://www.cancom.de/en/privacy-protection/" target="_blank" rel="noopener">
							<span>{{ 'app.footer.privacyProtection' | translate }}</span>
						</a>
						<a [href]="appService.docsUrl" target="_blank" rel="noopener">
							<span>{{ 'app.footer.docs' | translate }}</span>
						</a>
					</div>
				</div>
				<div fxFlex></div>
				<div fxLayoutAlign="start center">
					@if (featureFlagService.getFeatureFlagState('multiLanguage')) {
						<button matButton (click)="switchLanguage()" class="round-button languageSelector">
							<span fxLayout="row" fxLayoutGap="4px" fxLayoutAlign="start center">
								<mat-icon>language</mat-icon>
								<span>{{ translate.getCurrentLang().toUpperCase() }}</span>
							</span>
						</button>
					}
				</div>
			</footer>
		</mat-drawer-content>
	</mat-drawer-container>
</div>
